import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../../styles/Dashboard.css';
import Navbar from '../navbar';
import Sidebar from './../sidebar/index';
import Typography from '../../components/Typography';
import CustomButton from '../../components/CustomButton';
import { FaTimes } from 'react-icons/fa';
import CustomInput from '../../components/CustomInput';

const Support = () => {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [title, setTitle] = useState('');
    const [query, setQuery] = useState('');
    const [tickets, setTickets] = useState([]);
    const [filteredTickets, setFilteredTickets] = useState([]);
    const [statusFilter, setStatusFilter] = useState('All');
    const [error, setError] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [openIndex, setOpenIndex] = useState(null);
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const closeSidebar = () => {
        setIsSidebarOpen(false);
    };
    // Fetch user data
    useEffect(() => {
        const fetchUser = async () => {
            const token = localStorage.getItem('token');
            const userInfo = localStorage.getItem('userInfo');
            setUser(userInfo);
            if (!token || !userInfo) {
                navigate('/login');
                return;
            }
        };
        fetchUser();
    }, [navigate]);

    // Fetch tickets
    useEffect(() => {
        const fetchTickets = async () => {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    navigate('/login');
                    return;
                }

                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/ticket`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setTickets(response.data.tickets);
                console.log(response.data.tickets);
                // setFilteredTickets(response.data.tickets);
            } catch (err) {
                setError(err.message);
                if (err.message.includes('token')) navigate('/login');
            }
        };
        fetchTickets();
    }, [navigate]);

    // Filter tickets based on status
    useEffect(() => {
        if (statusFilter === 'All') {
            setFilteredTickets(tickets);
        } else {
            setFilteredTickets(tickets.filter((ticket) => ticket.status === statusFilter));
        }
    }, [statusFilter, tickets]);

    const handleCreateTicket = () => {
        setShowModal(true);
        setTitle('Create Ticket?');
    };

    const onClose = () => {
        setShowModal(false);
        setQuery('');
    };

    const handleSubmitTicket = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/ticket`,
                { query },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setTickets([response.data.ticket, ...tickets]);
            onClose();
        } catch (error) {
            setError(error.message);
        }
    };

    const formatDate = (dateString) => {
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: '2-digit',
            }).replace(/ /g, ' ');
        } catch {
            return 'Invalid Date';
        }
    };

    // if (!user || loading) return <div className="text-white text-center">Loading...</div>;
    if (error) return <div className="text-red-500 text-center">Error: {error}</div>;

    return (
        <div>
            {showModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center  bg-black bg-opacity-60 transition-all animate-backdropFadeIn">
                    <div className="relative animate-modalSlideIn">
                        <img
                            src={require('../../images/Rectangle 4488.png')}
                            alt="support"
                            className='sm:block hidden'
                            style={{ objectFit: 'cover' }}
                        />
                        <svg xmlns="http://www.w3.org/2000/svg" width="331" className='sm:hidden block' height="425" viewBox="0 0 331 425" fill="none">
                            <path d="M0 53.5L58.5 0H330.5V424.5H0V53.5Z" fill="#1B1B1B" />
                        </svg>
                        <div className="absolute inset-0 flex flex-col items-center text-white text-center sm:p-9 p-6">
                            <button
                                onClick={onClose}
                                className="absolute top-4 right-6 text-white text-lg hover:text-gray-300"
                                aria-label="Close modal"
                            >
                                <FaTimes size={20} />
                            </button>

                            <div className="mb-[28.51px]">
                                <div className="relative h-[92px] w-[93px] flex items-center justify-center">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="93"
                                        height="92"
                                        viewBox="0 0 93 92"
                                        fill="none"
                                        className="absolute top-0 left-0"
                                    >
                                        <path
                                            d="M32.9831 13.6308L60.193 13.3988L79.2382 32.1153L78.9624 58.8164L59.5271 77.8611L32.3172 78.0931L13.272 59.3766L13.5478 32.6754L32.9831 13.6308Z"
                                            fill="#DF0F11"
                                        />
                                    </svg>
                                    <div className="h-[30px] w-[19px]">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="19"
                                            height="30"
                                            viewBox="0 0 19 30"
                                            fill="none"
                                            className="relative z-20 h-full w-full"
                                        >
                                            <path
                                                d="M7.34091 20.4429V15.3857L14.6818 10.8V7.71429C14.6818 5.78572 13.1705 4.28572 11.2273 4.28572H7.77273C5.87273 4.28572 4.31818 5.82857 4.31818 7.71429V9.21429H0V7.71429C0 3.42857 3.49773 0 7.77273 0H11.2273C15.5455 0 19 3.42857 19 7.71429V13.1571L11.6591 17.7429V20.4429H7.34091ZM7.125 25.7143H11.875V30H7.125V25.7143Z"
                                                fill="#1B1B1B"
                                            />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                            <Typography text={title} className='sm:block hidden' transform={'uppercase'} family={'Supply'} size={'36px'} />
                            <div className="mx-5 sm:hidden block">
                                <Typography text={title} className='sm:hidden block' transform={'uppercase'} family={'Supply'} size={'28px'} />
                                <CustomInput
                                    className="mt-8"
                                    label={'Query'}
                                    value={query}
                                    onChange={(e) => setQuery(e.target.value)}
                                    placeholder={'Tell us whats wrong?'}
                                />
                            </div>
                            <CustomInput
                                className="mt-8 sm:block hidden"
                                label={'Query'}
                                value={query}
                                onChange={(e) => setQuery(e.target.value)}
                                placeholder={'Tell us whats wrong?'}
                            />
                            <CustomButton onClick={handleSubmitTicket} className="mt-10" text={'Create Ticket'} />
                            <Typography
                                className="mt-7"
                                size={'12px'}
                                weight={300}
                                letterspacing={'-0.96px'}
                                transform={'uppercase'}
                                lineheight={'170%'}
                                text={'*After creating, our team will reach out shortly.'}
                            />
                        </div>
                    </div>
                </div>
            )}
            <Navbar user={user} isSidebarOpen={isSidebarOpen}
                toggleSidebar={toggleSidebar}
                closeSidebar={closeSidebar} />
            <div className="flex"  >
                <Sidebar isOpen={isSidebarOpen} closeSidebar={closeSidebar} />
                <div className="w-full h-full min-h-screen sm:p-5 bg-[#121212] border-[#353535] border-l">
                    <div className="w-full p-5 rounded-[4px] bg-black flex flex-col ">
                        <div className="flex gap-4 justify-between sm:flex-row flex-col w-full">
                            <Typography
                                text={'Your Tickets'}
                                transform={'uppercase'}
                                color={'#FFF'}
                                size={'16px'}
                                weight={400}
                                lineheight={'170%'}
                                family={'Supply'}
                            />
                            <div className="flex items-center gap-1">
                                <button
                                    onClick={() => setStatusFilter('All')}
                                    className={`sm:inline-flex flex flex-1 h-7 px-[14px] py-[10px] justify-center items-center ${statusFilter === 'All' ? 'bg-[#DF0F11]  rounded-sm' : 'border-[1px] border-[#FFF]'
                                        }`}
                                >
                                    <Typography text={'All'} size={'12px'} color={'#FFF'} />
                                </button>
                                <button
                                    onClick={() => setStatusFilter('Pending')}
                                    className={`sm:inline-flex flex flex-1 h-7 px-[14px] py-[10px] justify-center items-center ${statusFilter === 'Pending' ? 'bg-[#DF0F11]  rounded-sm' : 'border-[1px] border-[#FFF]'
                                        }`}
                                >
                                    <Typography text={'Pending'} size={'12px'} color={'#FFF'} />
                                </button>
                                <button
                                    onClick={() => setStatusFilter('Completed')}
                                    className={`sm:inline-flex flex flex-1 h-7 px-[14px] py-[10px] justify-center items-center ${statusFilter === 'Completed' ? 'bg-[#DF0F11]  rounded-sm' : 'border-[1px] border-[#FFF]'
                                        }`}
                                >
                                    <Typography text={'Completed'} size={'12px'} color={'#FFF'} />
                                </button>
                            </div>
                        </div>
                        <div className='sm:hidden block'>
                            {filteredTickets.map((ticket, index) => (
                                <div
                                    key={index}
                                    className="border-b flex-col flex items-start border-gray-700 py-5 cursor-pointer"
                                    onClick={() => setOpenIndex(openIndex === index ? null : index)}
                                >
                                    <div className="flex flex-col  items-start self-stretch">
                                        <Typography text={ticket.ticketNo} opacity={0.6} size={'14px'} color='#FFF' />
                                        <div className="flex justify-between items-center self-stretch">
                                            <Typography onClick={() => navigate(`/support/tickets/${ticket._id}`)} className='hover:underline cursor-pointer' text={ticket.query} size={'18px'} color='#FFF' />
                                            {openIndex === index ? <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                <mask id="mask0_4672_17113" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14">
                                                    <rect width="14" height="14" transform="matrix(-4.37114e-08 1 1 4.37114e-08 0 3.05176e-05)" fill="#D9D9D9" />
                                                </mask>
                                                <g mask="url(#mask0_4672_17113)">
                                                    <path d="M12.6318 4.67558L11.804 3.84769L7.00049 8.65115L2.19704 3.84769L1.36914 4.67558L7.00049 10.3069L12.6318 4.67558Z" fill="#DF0F11" />
                                                </g>
                                            </svg> : <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                                <mask id="mask0_4672_17226" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="14">
                                                    <rect width="14" height="14" transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 14 14.0001)" fill="#D9D9D9" />
                                                </mask>
                                                <g mask="url(#mask0_4672_17226)">
                                                    <path d="M1.36815 9.32454L2.19605 10.1524L6.99951 5.34898L11.803 10.1524L12.6309 9.32454L6.99951 3.69318L1.36815 9.32454Z" fill="#DF0F11" />
                                                </g>
                                            </svg>}
                                        </div>
                                    </div>

                                    {/* Optional expanded content */}
                                    {openIndex === index && (
                                        <div className="flex flex-col mt-2 justify-center items-start self-stretch animation transition-all animate-backdropFadeIn">
                                            <div className="flex justify-between items-start self-stretch">
                                                <Typography text={'Created on'} opacity={0.6} size={'12px'} color='#FFF' />
                                                <Typography text={formatDate(ticket.createdOn)} size={'14px'} color='#FFF' />
                                            </div>
                                            <div className="flex justify-between items-start self-stretch">
                                                <Typography text={'Status'} opacity={0.6} size={'12px'} color='#FFF' />
                                                <Typography text={ticket.status} size={'14px'} color='#FFF' />
                                            </div>
                                            <div className="flex justify-between items-start self-stretch">
                                                <Typography text={'Last updated'} opacity={0.6} size={'12px'} color='#FFF' />
                                                <Typography text={formatDate(ticket.lastUpdated)} size={'14px'} color='#FFF' />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                        <div className="relative sm:block hidden w-full overflow-x-auto mt-3">
                            <table className="w-full text-sm text-left rtl:text-right">
                                <thead className="text-xs text-white opacity-60">
                                    <tr className="border-b border-[#151515]">
                                        <th scope="col" className="lg:px-6 px-1 py-3">
                                            <Typography text={'Ticket No.'} size={'14px'} weight={400} />
                                        </th>
                                        <th scope="col" className="w-[30%] lg:px-6 px-1 py-3">
                                            <Typography text={'Query'} size={'14px'} weight={400} />
                                        </th>
                                        <th scope="col" className="lg:px-6 px-1 py-3">
                                            <Typography text={'Created on'} size={'14px'} weight={400} />
                                        </th>
                                        <th scope="col" className="lg:px-6 px-1 py-3">
                                            <Typography text={'Status'} size={'14px'} weight={400} />
                                        </th>
                                        <th scope="col" className="lg:px-6 px-1 py-3">
                                            <Typography text={'Last updated'} size={'14px'} weight={400} />
                                        </th>
                                        <th scope="col" className="lg:px-6 px-1 py-3"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredTickets.map((ticket) => (
                                        <tr
                                            key={ticket._id}
                                            className="border-b py-4 animate-backdropFadeIn border-[#151515] h-[50px] text-white"
                                        >
                                            <td className="lg:px-6 px-1">
                                                <Typography text={ticket.ticketNo} size={'14px'} weight={400} />
                                            </td>
                                            <td className="lg:px-6 px-1">
                                                <Typography text={ticket.query} size={'14px'} weight={400} />
                                            </td>
                                            <td className="lg:px-6 px-1">
                                                <Typography text={formatDate(ticket.createdOn)} size={'14px'} weight={400} />
                                            </td>
                                            <td className="lg:px-6 px-1">
                                                <Typography
                                                    text={ticket.status}
                                                    size={'14px'}
                                                    weight={400}
                                                    color={ticket.status === 'Pending' ? '#EF4444' : '#10B981'}
                                                />
                                            </td>
                                            <td className="lg:px-6 px-1">
                                                <Typography text={formatDate(ticket.lastUpdated)} size={'14px'} weight={400} />
                                            </td>
                                            <td className="lg:px-6 px-1 ml-auto flex justify-end py-3">
                                                <button
                                                    onClick={() => navigate(`/support/tickets/${ticket._id}`)}
                                                    className="flex w-[105px] h-7 items-center justify-center rounded-sm px-[18px] py-[10px] border-[#FFF] border-[1px]"
                                                >
                                                    <Typography
                                                        text={'View'}
                                                        color={'#FFF'}
                                                        opacity={'0.6'}
                                                        size={'12px'}
                                                        weight={400}
                                                        lineheight={'170%'}
                                                    />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="w-full flex justify-center mt-4 items-center">
                            <button
                                onClick={handleCreateTicket}
                                className="px-[14px] py-[10px] flex w-full justify-center items-center gap-1 flex-shrink-0 rounded-sm bg-white h-8 box-border"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                    fill="none"
                                >
                                    <mask id="mask0_498_558" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="12" height="12">
                                        <rect width="12" height="12" fill="#D9D9D9" />
                                    </mask>
                                    <g mask="url(#mask0_498_558)">
                                        <path d="M5.5 6.5H2.5V5.5H5.5V2.5H6.5V5.5H9.5V6.5H6.5V9.5H5.5V6.5Z" fill="black" />
                                    </g>
                                </svg>
                                <Typography text={'Create a new ticket'} size={'12px'} color={'#000'} />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Support;